import script from "./base-radio.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-radio.vue?vue&type=script&setup=true&lang=ts"

import "./base-radio.vue?vue&type=style&index=0&id=ab3c19a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab3c19a0"]])

export default __exports__